import React from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";

const TwilioSMSSettings = () => {
  return (
    <>
      <div className="hstack justify-content-between mb-2 pt-3 px-3 pb-1">
        <Form.Group>
          <h6 className="m-0 d-block">Add New Inbox</h6>
          <Form.Text style={{ fontSize: 12 }}>
            To connect your Twilio SMS channel, select a Twilio account, choose
            a verified phone number, and set an inbox name.
          </Form.Text>
        </Form.Group>
        {/* <Form.Group>
          <h6 className="m-0 d-block">Connect New Account</h6>
          <Form.Text style={{ fontSize: 12 }}>
            To connect your Twilio SMS channel, please provide your Twilio
            Account SID and Auth Token, then choose a phone number and set an
            inbox name.
          </Form.Text>
        </Form.Group> */}
        <Button size="sm">Save</Button>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 127px)" }}>
        <div className="px-3 pb-3">
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4">
              <Form.Group className="mb-2">
                <Row className="g-2">
                  <Col xs={12}>
                    <Form.Label className="m-0">Twilio Account</Form.Label>
                    <Form.Select>
                      <option>Select Account</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Phone Number</Form.Label>
                    <Form.Select>
                      <option>Select Account</option>
                    </Form.Select>
                  </Col>
                  <Col xs={12} md={6}>
                    <Form.Label className="m-0">Connection Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Connection Name"
                    />
                  </Col>
                </Row>

                {/* Create Twilio SMS Account */}

                {/* <Row className="g-2">
                  <Col xs={6}>
                    <Form.Label className="m-0">Account SID</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Connection Name"
                    />
                  </Col>
                  <Col xs={6}>
                    <Form.Label className="m-0">Auth Token</Form.Label>
                    <Form.Control type="text" placeholder="Enter Auth Token" />
                  </Col>
                </Row>
                <Form.Text style={{ fontSize: 13 }}>
                  Note: Your credentials are securely encrypted and stored. We
                  use them only to connect your Twilio phone numbers to site pallet.
                </Form.Text> */}
              </Form.Group>
            </Card.Body>
          </Card>
        </div>
      </div>
    </>
  );
};

export default TwilioSMSSettings;
